import React from 'react';
import Logs from 'components/Logs';

const AlarmLogs = ({ id }) => {
  return (
    <Logs
      targetId={parseInt(id)}
      targetType="ConditionalInstance"
      title="Alarm logs"
      height={439}
    />
  );
};

export default AlarmLogs;
